export default __webpack_public_path__ + "static/media/newsletter.01145b9f.svg";